import SectionHeading from "../common/SectionHeading";
import "./WhyChooseUs.css";

const REASONS = [
  { n: "01", title: "Professional Training Environment", desc: "A focused, well-maintained floor built for serious training, not distraction." },
  { n: "02", title: "Modern Fitness Equipment", desc: "Strength, functional and cardio stations kept in working order and up to date." },
  { n: "03", title: "Goal-Oriented Workouts", desc: "Every plan is built around a defined outcome — strength, size, endurance or fat loss." },
  { n: "04", title: "Personal Attention", desc: "Coaches who correct your form and track your progress, not just count reps." },
  { n: "05", title: "Friendly Gym Community", desc: "A member base that shows up, pushes each other, and makes consistency easier." },
  { n: "06", title: "Convenient Coimbatore Location", desc: "Based in Peelamedu on Vilangurichi Road — easy to reach, easy to stay consistent." },
];

export default function WhyChooseUs() {
  return (
    <section className="why-us section">
      <div className="container">
        <SectionHeading eyebrow="Why Firm Fit Factory" title="Built different," highlight="built for results" align="center" />
        <div className="why-us__grid">
          {REASONS.map((r) => (
            <div className="why-us__item" key={r.n}>
              <span className="why-us__num">{r.n}</span>
              <h3>{r.title}</h3>
              <p>{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
